module.exports = __webpack_public_path__ + "static/media/Cam_2.f4c8a979.webp";